import { Component, AfterViewInit, inject, signal, WritableSignal, computed, Inject, PLATFORM_ID, ChangeDetectorRef, Input, Pipe, viewChild, Signal, OnDestroy } from '@angular/core';
import { FormsModule, ReactiveFormsModule, FormControl } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatStep, MatStepper, MatStepperModule } from '@angular/material/stepper';
import { MatButtonModule } from '@angular/material/button';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE, provideNativeDateAdapter } from '@angular/material/core';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { AddressService, NavegoAddressResponse } from '../../shared/address.service';
import { PersonalInformation } from './signup.types';
import { CommonModule, isPlatformBrowser, Location } from '@angular/common';
import { AccountService, PaymentMethod } from '../../shared/account.service';
import { Router, RouterLink } from '@angular/router';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { CUSTOM_DATE_FORMATS } from '../../shared/constants/date-formtats';
import { LocalStorageService } from '../../shared/local-storage.service';
import { SignalsStoreService } from '../../shared/signals-store.service';
import { Session } from '../../shared/types/session.type';
import { FIREBASE_COLLECTIONS, LOCALSTORAGE_KEYS } from '../../shared/constants/databases';
import { ArrayOptionsItem, NewAccountPayload, AccountSettings, DeliveryOptionsResponseItem, PeopleShoppingFor, Reference } from '../../shared/types/account.types';
import { PaymentMethodService } from '../../settings/billing/payment-method/payment-method.service';
import { MatRadioModule } from '@angular/material/radio';
import { PersonalInformationSignupComponent } from './personal-information-signup/personal-information-signup.component';
import { CheckAddressSignupComponent } from './check-address-signup/check-address-signup.component';
import { PaymentMethodSignupComponent } from './payment-method-signup/payment-method-signup.component';
import { ProfileService } from '../../settings/account/profile/profile.service';
import { auditTime, bufferWhen, catchError, delay, filter, finalize, map, mergeMap, of, scan, startWith, Subject, switchMap, tap, timer } from 'rxjs';
import { ProductsService } from '../../product/products.service';
import { FarmboxChoosingSignupComponent } from './farmbox-choosing-signup/farmbox-choosing-signup.component';
import { HeaderService } from '../../shared/header/header.service';
import { environment } from '../../../environments/environment';
import { SignUpSteps } from '../../shared/types/common.enums';
import { FirebaseCrudService } from '../../shared/firebase-crud.service';
import { ModalContentService } from '../../shared/modal-content/modal-content.service';
import { ApiResponse } from '../../shared/common/types';
import { HTTP_STATUS_CODES } from '../../shared/constants/errors';
import { ModalContentTypes } from '../../shared/constants/modal-content-types';
import { FaqsComponent } from './faqs/faqs.component';
import { OrderService } from '../../shared/order.service';
import { DeliveriesService } from '../../settings/account/deliveries/deliveries.service';
import { FooterComponent } from '../../shared/footer/footer.component';
import { ResolutionService } from '../../shared/resolution.service';
import { scrollToTop } from '../../shared/common/utils';
import { Product, ProductResume } from '../../product/product.types';
import { MarketingReferral } from '../../shared/types/common.types';
import { checkSignupCouponCodes } from '../../shared/common/singup.utils';
import { PromotionsService } from '../../shared/promotions.service';
import { NotificationService } from '../../shared/notification/notification.service';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { MatDividerModule } from '@angular/material/divider';
import { LoadingService } from '../../shared/loading.service';
import { SubscriptionsService } from '../../settings/account/subscriptions/subscriptions.service';
import { SubscriptionPayload } from '../../settings/account/subscriptions/subscriptions.types';

@Component({
  selector: 'app-signup',
  providers: [provideNativeDateAdapter(),
  { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
  { provide: MAT_DATE_FORMATS, useValue: CUSTOM_DATE_FORMATS.MONTH_AND_YEAR },
    PaymentMethodService,
    ProfileService
  ],
  imports: [
    CommonModule,
    MatButtonModule,
    MatStepperModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatSlideToggleModule,
    MatCheckboxModule,
    MatDatepickerModule,
    MatAutocompleteModule,
    MatProgressBarModule,
    RouterLink,
    MatRadioModule,
    CheckAddressSignupComponent,
    PersonalInformationSignupComponent,
    FarmboxChoosingSignupComponent,
    PaymentMethodSignupComponent,
    FaqsComponent,
    FooterComponent,
    NgbTooltip,
    MatDividerModule
  ],
  templateUrl: './signup.component.html',
  styleUrl: './signup.component.scss'
})

export class SignupComponent implements AfterViewInit, OnDestroy {
  public localStorageService = inject(LocalStorageService);
  private signalsStoreService = inject(SignalsStoreService);
  private addressService = inject(AddressService);
  private profileService = inject(ProfileService);
  private productsService = inject(ProductsService);
  private headerService = inject(HeaderService);
  private firebaseCrudService = inject(FirebaseCrudService);
  #modalContentService = inject(ModalContentService);
  #router = inject(Router);
  #orderService = inject(OrderService);
  accountService = inject(AccountService);
  #deliveriesService = inject(DeliveriesService);
  cdr = inject(ChangeDetectorRef)
  #resolutionService = inject(ResolutionService);
  #location = inject(Location);
  #promotionsService = inject(PromotionsService);
  #notificationService = inject(NotificationService);
  private loadingService = inject(LoadingService);
  private subscriptionsService = inject(SubscriptionsService);

  deliveryOption = [
    'Home Delivery',
    'Pick Up',
    'EBT/Snap'
  ];

  // @ViewChild('stepper', { static: false }) matStepper!: MatStepper;
  matStepper: Signal<MatStepper> = viewChild.required('stepper');
  personalInformationComponent: Signal<PersonalInformationSignupComponent> = viewChild.required('personalInformationComponent');

  firstStep = viewChild.required<MatStep>('firstStep');
  preferencesStep = viewChild.required<MatStep>('preferencesStep');
  paymentMethodStep = viewChild.required<MatStep>('paymentMethodStep');
  personalInfoStep = viewChild.required<MatStep>('personalInfoStep');
  farmboxStep = viewChild.required<MatStep>('farmboxStep');


  @Input() formValidityPersonalInformation: boolean | undefined;
  @Input() formValidityPreferences: boolean | undefined;
  @Input() formValidityPaymentMethod: boolean | undefined;
  @Input() deliveryAddressInformation: any;
  @Input() deliverySelectedDay: any;
  @Input() deliveryOptionSelected: any;
  @Input() personalInformationData: any;
  @Input() shopforValue: any;
  @Input() dietaryRestrictionsValues: any;
  @Input() farmboxCardSubscription: any
  isLinear = true;
  paymentMethodStepControl: FormControl = new FormControl(true);

  personalInformation: WritableSignal<PersonalInformation | null | any> = signal(null)

  referralSource: Reference[] = [];
  deliveryOptions: DeliveryOptionsResponseItem[] = [];
  skipPaymentMethodStep: boolean = false;

  paymentMethod: WritableSignal<PaymentMethod> = signal({
    cardCode: '',
    firstName: '',
    lastName: '',
    cardNumber: '',
    email: '',
    expirationDate: '',
  })

  states: WritableSignal<ArrayOptionsItem[]> = signal([]);

  date = new FormControl({ value: new Date(''), disabled: true });

  isCheckedDietaryRestrictions: boolean = false;
  isCheckedAddAnotherContact: WritableSignal<boolean> = signal(false);
  isCheckedBillingAddress: WritableSignal<boolean> = signal(false);
  isCheckedCouponCode: boolean = false;
  isCheckedTermsAndConditions: boolean = false;

  isGoogleAddressFilled = signal(false);
  isLoadingContent: any = this.addressService.isLoading
  isWaitingResponse: any = signal(false)
  hasDeliveryAddressCoverage: any = signal(false);

  selectedDeliveryDay: WritableSignal<DeliveryOptionsResponseItem | null> = signal(null);
  selectedDeliveryTimeWindow: any = signal(null);
  selectedMonth: any = null;
  selectedYear: any = null;
  isPasswordValid1 = computed(() => !!(this.passwordConditions.every(condition => condition.valid())));
  isValidFormDeliveryAddress = computed(() => this.hasDeliveryAddressCoverage() && !!this.selectedDeliveryDay() && !!this.selectedDeliveryTimeWindow());

  personalInformationValidations = new Map<string, WritableSignal<{ valid: boolean, error: string, validations: string[] }>>();
  shouldDisableCreateClientButton = signal(false);

  paymentMethodValidations = new Map<string, WritableSignal<{ valid: boolean, error: string, validations: string[] }>>();


  isMinLengthValid = computed(() => (this.personalInformation()?.password ?? '').length >= 8)
  hasUpperCase = computed(() => /[A-Z]/.test(this.personalInformation()?.password || ''))
  hasLowerCase = computed(() => /[a-z]/.test(this.personalInformation()?.password || ''))
  hasSpecialChar = computed(() => /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/.test(this.personalInformation()?.password || ''))
  hasNumber = computed(() => /\d/.test(this.personalInformation()?.password || ''))
  passwordConditions = [
    { label: 'At least 8 Characters', iconClass: (this.isMinLengthValid() ? 'fa-check' : 'fa-check'), valid: () => this.isMinLengthValid() },
    { label: 'At least 1 Number (0-9) or 1 Symbol', iconClass: ((this.hasNumber() || this.hasSpecialChar()) ? 'fa-check' : 'fa-check'), valid: () => (this.hasNumber() || this.hasSpecialChar()) },
    { label: 'At least 1 Lowercase (a-z)', iconClass: (this.hasLowerCase() ? 'fa-check' : 'fa-check'), valid: () => this.hasLowerCase() },
    { label: 'At least 1 Uppercase (A-Z)', iconClass: (this.hasUpperCase() ? 'fa-check' : 'fa-check'), valid: () => this.hasUpperCase() }
  ];
  isMobile = computed(() => this.#resolutionService.isMobile());

  shouldSetUpSettings: boolean = true;

  logoVersionNumber = computed(() => this.signalsStoreService.logoVersionNumber());

  bundleProducts = signal<ProductResume[]>([]);

  signupPromotionInfo = computed(() => this.signalsStoreService.signupPromotionInfo());

  isLoadedMarketingValidations = computed(() => this.signalsStoreService.isLoadedMarketingValidation());

  isTryingToApplyCoupon = signal(false);

  productDetails = signal<Map<number, Product>>(new Map()); // Cache of product details

  #visibleProducts$ = new Subject<number[]>(); // IDs of products that are visible in the viewport

  signupPromotionInfoFromLS = computed(() => this.signalsStoreService.signupPromotionInfoLS());

  constructor(@Inject(PLATFORM_ID) private platformId: any) {
    this.signalsStoreService.isInSignUpComponent.set(true);
  }

  ngOnDestroy(): void {
    this.signalsStoreService.isInSignUpComponent.set(false);
  }

  ngAfterViewInit() {
    if (!isPlatformBrowser(this.platformId)) return;

    const currentStep = this.localStorageService.get<number>(LOCALSTORAGE_KEYS.SIGNUP_CURRENT_STEP);

    if (this.signalsStoreService.hasSession() && this.signalsStoreService.sessionSignal()?.settings?.hasPaymentMethod) {
      this.#location.replaceState('/shop');
      window.location.reload();
      return;
    }

    const existingSelectedProduct: any = this.localStorageService
      .get(LOCALSTORAGE_KEYS.PRODUCTS_TO_SUBSCRIBE);

    const stepToLoad = this.signalsStoreService.hasSession()
      ? currentStep ?? SignUpSteps.paymentInformation
      : existingSelectedProduct?.id ? SignUpSteps.deliveryInformation : SignUpSteps.selectYourFarmbox;

    // Load first step or farmbox subscription step if hasSession
    if (stepToLoad > 0) {
      for (let index = 0; index < stepToLoad; index++) {
        this.matStepper().steps.toArray()[index].completed = true;
      }
    }

    if (stepToLoad === SignUpSteps.selectYourFarmbox) {
      this.headerService.getFrequencies();
      this.getBundleProducts();
    } else if (stepToLoad === SignUpSteps.paymentInformation)
      this.signalsStoreService.getAndSyncCart();

    this.matStepper().selectedIndex = stepToLoad;
    this.cdr.detectChanges();
    this.#setupBatchRequests();

    setTimeout(() => {
      scrollToTop('scroll-to-top-ref');
    }, 500);

  }

  createNewClient() {
    if (this.shouldDisableCreateClientButton()) return;
    this.shouldDisableCreateClientButton.set(true);
    const payload = this.setUpNewClientPayload();
    if (!payload) return;

    this.accountService
      .create(payload)
      .pipe(
        delay(1000),
        finalize(() => this.shouldDisableCreateClientButton.set(false))
      )
      .subscribe({
        next: (res: ApiResponse<Session>) => {
          console.log('Response from createNewClient:', res);
          const { data, status } = res;
          if (status === HTTP_STATUS_CODES.CONFLICT) {
            this.loadingService.close();
            return this.#showModalEmailAlreadyInUse(payload.accountInfo.email);
          }
          if (data?.isTimeSlotCapacityFull) {
            this.selectedDeliveryDay.set(null);
            this.selectedDeliveryTimeWindow.set(null);
            this.getDeliveryOptions();
            this.firstStep().editable = true;
            this.matStepper().previous();
            this.loadingService.close();
          } else if (data && data?.accountInfo?.id) {
            console.log('New client created successfully:', data);
            this.#deliveriesService.getDeliveryZoneInfo().pipe(finalize(() => {
              console.log('Delivery zone info retrieved successfully');
              this.loadingService.open()
              this.#setUpNewClient(data.accountInfo.id);
            })).subscribe();
            this.signalsStoreService.getAndSyncCart();
          }

          scrollToTop('scroll-to-top-ref');
        }
      });
  }

  async #setUpNewClient(accountId: number) {
    console.log('Setting up new client with accountId:', accountId);
    const product: any = this.localStorageService
      .get(LOCALSTORAGE_KEYS.PRODUCTS_TO_SUBSCRIBE);

    console.log('Product to subscribe:', product);

    await this.firebaseCrudService
      .add(
        FIREBASE_COLLECTIONS.ERROR_SIGNUP,
        accountId,
        {
          product: product ?? {},
          accountId,
          date: new Date().toUTCString(),
          step: 'newClient'
        }
      );

    console.log('Error signup document created successfully');

    if (product) {
      const subs: SubscriptionPayload = {
        frequencyId: product.subscription.frequency.id,
        quantity: product.quantity,
        variantId: product.variant.id,
        packageId: product.package?.id ?? null,
        startDate: null,
        isSignup: true
      };
      this.subscriptionsService
        .create(subs)
        .pipe(
          tap(async () => {

            let session: Session | null = this.localStorageService.get(LOCALSTORAGE_KEYS.SESSION);
            if (session && session.subscriptionRequirement) {
              session.subscriptionRequirement.subscriptionRequirementMet = true;

              this.localStorageService.set(LOCALSTORAGE_KEYS.SESSION, session);
            }

          }),
          catchError((error) => {
            console.error('Error creating subscription:', error);
            return of(null);
          }),
          finalize(() => {
            this.localStorageService.remove(LOCALSTORAGE_KEYS.PRODUCTS_TO_SUBSCRIBE);
            this.continue();
          })
        )
        .subscribe();
    }

  }

  #showModalEmailAlreadyInUse(email: string) {
    this.#modalContentService.openModal(ModalContentTypes.CONFIRMATION, {
      title: 'Email already in use',
      textContent: `Hey! Looks like you already have an account with us. Would you like to login with <b><i>${email}</i></b>?`,
      cancelButtonText: 'Try another email',
      confirmButtonText: 'Click here to login',
    }).closed
      .subscribe((res: { confirm: boolean } | null) => {
        if (!res?.confirm) return this.personalInformationComponent().clearEmailField();
        this.localStorageService.set(LOCALSTORAGE_KEYS.PRELOADED_EMAIL, email);
        this.#router.navigate(['/login']);
      })
  }

  async #saveStepInFirebase(stepIndex: number, accountId?: number) {

    if (!accountId) {

      const sessionStored: Session | null = this.localStorageService.get(LOCALSTORAGE_KEYS.SESSION);
      if (!sessionStored)
        return;

      accountId = sessionStored.accountInfo.id;
    }

    const id: number = accountId;

    const exists = await this.firebaseCrudService.existsDoc(FIREBASE_COLLECTIONS.SIGNUP_STEP, id.toString());
    const data = {
      stepIndex
    };

    if (exists)
      this.firebaseCrudService.update(FIREBASE_COLLECTIONS.SIGNUP_STEP, id, data);
    else
      this.firebaseCrudService.add(FIREBASE_COLLECTIONS.SIGNUP_STEP, id, data);

  }

  private getDeliveryOptions() {
    this.accountService.getDeliveryOptions(this.addressService.navegoAddress()?.zoneId).subscribe({ next: (options: DeliveryOptionsResponseItem[]) => this.deliveryOptions = options });
  }

  private setUpNewClientPayload(): NewAccountPayload | null {
    try {

      const {
        firstName,
        lastName,
        phone,
        email,
        password,
        dietaryRestrictions = this.dietaryRestrictionsValues,
        shopfor = this.shopforValue,
        contactPerson: contact,
        referralSource,
        additionalInfo,
        receiveNewsletter,
        receiveText,
        receiveTextDelivery
      } = this.personalInformationData() || {};
      const { additionalAddress: additional, zipCode: zip, deliveryNotes: noteDriver } = this.deliveryAddressInformation()
      const { street, zoneId, city, state: stateCode, latitude, longitude } = this.addressService.navegoAddress() as NavegoAddressResponse || {}
      return {
        accountInfo: {
          dietaryPreferences: dietaryRestrictions?.filter((value: any) => value.completed).map((value: any) => { return { id: value.id, name: value.name } }) || null,
          email,
          firstName,
          lastName,
          noteDriver,
          password,
          phone,
        },
        address: {
          additional: additional || null,
          city: city || null,
          latitude: latitude || null,
          longitude: longitude || null,
          stateCode: stateCode || null,
          street: street || null,
          zip: zip || null,
          zoneId: zoneId || this.deliverySelectedDay[0].zoneId
        },
        settings: {
          receiveNewsletter,
          receiveText,
          receiveTextDelivery,
          delivery: {
            type: this.deliveryOptionSelected?.id,
            dayId: this.deliverySelectedDay.id || this.deliverySelectedDay[0]?.deliveryDay || null,
            timeWindowId: this.selectedDeliveryTimeWindow() === -1 ? null : this.selectedDeliveryTimeWindow()
          },
          peopleShoppingForId: shopfor,
          referral: {
            additionalInfo,
            source: referralSource
          },
        },
        contact
      } as NewAccountPayload | any
    } catch (error) {
      console.log('error >>>', error);
      return null;
    }
  }

  updateCreatedClient() {
    const payload = this.setUpUpdateClientPayload();
    this.profileService.putPreferences(payload).pipe(
      tap(() => {
        this.matStepper().next();
      })
    ).subscribe()
  }

  private setUpUpdateClientPayload(): any | null {
    try {
      const { dietaryRestrictions = this.dietaryRestrictionsValues, shopfor = this.shopforValue } = this.personalInformationData() || {};
      return {
        accountInfo: {
          dietaryPreferences: dietaryRestrictions?.filter((value: any) => value.completed).map((value: any) => { return { id: value.id, name: value.name } }) || null,
        },
        settings: {
          peopleShoppingForId: shopfor
        }
      } as any
    } catch (error) {
      console.log('error >>>', error);
      return null;
    }
  }

  continue() {
    let closeLoadingService = true;

    switch (this.matStepper().selectedIndex) {
      case 0:
        this.farmboxStep().completed = true;
        break;
      case 1:
        this.firstStep().completed = true;
        break;
      case 2:
        this.personalInfoStep().completed = true;
        break;
      case 3:
        closeLoadingService = false;
        this.paymentMethodStep().completed = true;
        this.#location.replaceState('/preferences');
        window.location.reload();
        break;
      default:
        break;
    }

    if (this.matStepper().selectedIndex === SignUpSteps.paymentInformation)
      return;

    this.matStepper().next();

    if (closeLoadingService)
      this.loadingService.close();

    const { selectedIndex } = this.matStepper();
    this.localStorageService.set(LOCALSTORAGE_KEYS.SIGNUP_CURRENT_STEP, selectedIndex);

    if (selectedIndex === SignUpSteps.personalInformation) {
      this.firstStep().editable = false;
      if (this.shouldSetUpSettings) {
        this.getAccountSettings();
        this.shouldSetUpSettings = false;
      }
    } else if (selectedIndex === SignUpSteps.paymentInformation)
      this.#saveStepInFirebase(SignUpSteps.paymentInformation);

    scrollToTop('scroll-to-top-ref');
  }

  private getBundleProducts() {

    this.productsService
      .getProductsByCategoryIdResume(environment.config.bundleCategoryId)
      .pipe(
        tap(response => this.bundleProducts.set(response?.data?.products ?? []))
      )
      .subscribe();
  }

  private getAccountSettings() {
    this.accountService.getAccountSettings().subscribe({
      next: (accountSettings: AccountSettings | null) => {
        if (accountSettings) {
          this.setUpAccountSettings(accountSettings);
        }
      }
    });

  }

  private setUpAccountSettings(accountSettings: AccountSettings) {
    this.personalInformation.set({
      contactPerson: {
        email: null,
        firstName: null,
        lastName: null,
        phone: null,
      },
      dietaryRestrictions: accountSettings.dietaryPreferences?.map((preference: ArrayOptionsItem) => {
        return { ...preference, completed: false };
      }) || [],
      peopleShoppingFor: accountSettings.peopleShoppingFor || [],
      email: '',
      firstName: '',
      lastName: '',
      password: '',
      phone: '',
      referralSource: '',
      advertisement: '',
      shopfor: null,
    });

    this.referralSource = accountSettings.references;
  }

  isCompleteStep1(): boolean {
    return (this.hasDeliveryAddressCoverage() && !!this.selectedDeliveryDay()) &&
      ((this.selectedDeliveryDay()?.allowTimeWindow && !!this.selectedDeliveryTimeWindow()) || !this.selectedDeliveryDay()?.allowTimeWindow);
  }

  #setupBatchRequests() {
    const noActivity$ = this.#visibleProducts$.pipe(
      switchMap(() => timer(100).pipe(map(() => true))), // Si no hay nuevos valores en 500ms → inactividad
      startWith(false) // Al inicio hay actividad
    );

    this.#visibleProducts$.pipe(
      bufferWhen(() => noActivity$.pipe(filter(inactive => inactive))), // Espera a que haya inactividad
      filter(productGroups => productGroups.length > 0), // Evita procesar arrays vacíos
      mergeMap(productGroups => productGroups.flat()), // 🔄 Aplana el array → number[]
      scan((acc: number[], productId: number) => [...new Set([...acc, productId])], []), // 📌 Acumula productos únicos
      auditTime(500), // ⏳ Espera estabilidad antes de hacer la petición
      switchMap(productIds => {
        // console.log("📌 Productos acumulados para fetch:", productIds);
        const idsToFetch = productIds.filter(id => !this.productDetails().has(id));
        // console.log("⚠️ Productos a buscar:", idsToFetch);
        return idsToFetch.length > 0 ? this.productsService.getProductsDetailsByIds(idsToFetch) : of({});
      })
    ).subscribe(details => {
      this.productDetails.update(prev => {
        // console.log("✅ Detalles recibidos:", details);
        const updatedMap = new Map(prev); // Clonar el Map existente
        Object.entries(details).forEach(([index, detail]) => {
          const productDetail: Product = detail as Product;
          updatedMap.set(Number(productDetail.id), productDetail as Product); // Convertir id a número y agregarlo
        });
        return updatedMap;
      });
    });
  }

  onProductCardReady(productId: number) {
    if (this.productDetails().has(productId)) return;
    else this.#visibleProducts$.next([productId]);
  }

  onProductCardHover(productId: number) {
    if (this.productDetails().has(productId)) return;
    else this.#visibleProducts$.next([productId]);
  }

  applySignupCoupon(code: string) {

    if (!code) return this.#notificationService.show({ text: 'You should provide a coupon code.', type: 'error' });

    this.isTryingToApplyCoupon.set(true);

    const marketingReferral: MarketingReferral = {
      utmCampaign: code
    };

    checkSignupCouponCodes({
      marketingReferral,
      signalsStoreService: this.signalsStoreService,
      localStorageService: this.localStorageService,
      promotionsService: this.#promotionsService,
      showDefaultMessage: true
    }).pipe(
      tap(res => {
        if (res.name) {
          const currentPath = this.#location.path().split('?')[0];
          this.#location.replaceState(currentPath);
        }
      })
    ).subscribe();

  }

  clearSignupPromotionInfo() {
    this.signalsStoreService.setSignupPromotionInfo(null);
  }

  restoreSignupInfo() {
    const signupPromotionInfo = this.localStorageService.get(LOCALSTORAGE_KEYS.PROMOTION_INFO);
    if (!signupPromotionInfo) return;
    this.signalsStoreService.setSignupPromotionInfo(signupPromotionInfo);
  }
}
